// extracted by mini-css-extract-plugin
export var auth = "Authenticator-module--auth--HLA48";